import { messages } from './MedicalNotes.i18n';

export const dateButtonGroupConfig = (props, formatMessage) => ({
  defaultValue: 'All',
  value: (props.filter) ? (props.filter.date || 'All') : 'All',
  id: 'date-filter-input-group',
  filterConfig: [
    {
      filterTitle: formatMessage(messages.filter.allDates),
      filterValue: 'All',
    },
    {
      filterTitle: formatMessage(messages.filter.last3months),
      filterValue: 'Last 3 months',
    },
    {
      filterTitle: formatMessage(messages.filter.last6months),
      filterValue: 'Last 6 months',
    },
    {
      filterTitle: formatMessage(messages.filter.last9months),
      filterValue: 'Last 9 months',
    },
  ],
  xsSize: 12,
  smSize: 12,
  mdSize: 6,
});

const setupFilterDropdown = (firstOptionText, filterValue, filterOptions, attribute, className) => {
  // filterOptions parameter expects an array of stirngs.
  const options = filterOptions.map((optionText) =>
    ({
      optionText,
      optionValue: {
        [attribute]: optionText,
      },
    }));

  const defaultOptionValue = {
    [attribute]: '',
  };

  // insert as first item
  options.unshift(
    {
      optionText: firstOptionText,
      optionValue: defaultOptionValue,
    }
  );

  // Display filter value if present otherwise display text of the first option item.
  const selectedOptionValue = (filterValue ?
    {
      [attribute]: filterValue,
    } :
    defaultOptionValue);

  return {
    defaultOptionValue,
    value: selectedOptionValue,
    options,
    className,
  };
};

export const typeDropdownConfig = (props, filterOptions, formatMessage) => setupFilterDropdown(
  formatMessage(messages.filter.allTypes),
  (props.filter && props.filter.documentType) ? props.filter.documentType : '',
  filterOptions,
  'documentType',
  'leftJustified');

export const authorDropdownConfig = (props, filterOptions, formatMessage) => setupFilterDropdown(
  formatMessage(messages.filter.allCareProviders),
  (props.filter && props.filter.authoredBy) ? props.filter.authoredBy : '',
  filterOptions,
  'authoredBy',
  'leftJustified');
